import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ApiService } from '@services/api.service';
import {
  CustomTestDefinition,
  SaveCustomTestDefinitionDto,
} from '../models/custom-test-definition.model';

@Injectable({ providedIn: 'root' })
export class CustomTestDefinitionService {
  private readonly api = inject(ApiService);

  private readonly basePath = 'custom-test-definitions';

  getAll(): Observable<CustomTestDefinition[]> {
    return this.api.get(this.basePath).pipe(
      map((items: CustomTestDefinition[]) => items)
    );
  }

  getById(id: string): Observable<CustomTestDefinition> {
    return this.api.get(`${this.basePath}/${id}`).pipe(
      map((item: CustomTestDefinition) => item)
    );
  }

  create(dto: SaveCustomTestDefinitionDto): Observable<CustomTestDefinition> {
    return this.api.post(this.basePath, dto).pipe(
      map((item: CustomTestDefinition) => item)
    );
  }

  update(id: string, dto: SaveCustomTestDefinitionDto): Observable<CustomTestDefinition> {
    return this.api.put(`${this.basePath}/${id}`, dto).pipe(
      map((item: CustomTestDefinition) => item)
    );
  }

  delete(id: string): Observable<void> {
    return this.api.delete(`${this.basePath}/${id}`);
  }
}
